/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1Attachment } from '../models/V1Attachment';
import { V1Excludes } from '../models/V1Excludes';
import { V1Includes } from '../models/V1Includes';
import { V1TemplateVariableValue } from '../models/V1TemplateVariableValue';
import { HttpFile } from '../http/http';

export class AdvertisingPlatformServiceTriggerRouteRequest {
    'orgId'?: string;
    'templateVariables'?: { [key: string]: V1TemplateVariableValue; };
    'attachments'?: Array<V1Attachment>;
    'includes'?: V1Includes;
    'excludes'?: V1Excludes;
    /**
    * Conditionals Override: when set to true, the route will override any conditionals set on the templates and send all templates regardless of the conditionals. This is useful for testing or when you want to force the route to send all templates regardless of the conditionals.
    */
    'overrideConditionals'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "templateVariables",
            "baseName": "template_variables",
            "type": "{ [key: string]: V1TemplateVariableValue; }",
            "format": ""
        },
        {
            "name": "attachments",
            "baseName": "attachments",
            "type": "Array<V1Attachment>",
            "format": ""
        },
        {
            "name": "includes",
            "baseName": "includes",
            "type": "V1Includes",
            "format": ""
        },
        {
            "name": "excludes",
            "baseName": "excludes",
            "type": "V1Excludes",
            "format": ""
        },
        {
            "name": "overrideConditionals",
            "baseName": "override_conditionals",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return AdvertisingPlatformServiceTriggerRouteRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

